import React from 'react'
import { Link } from 'react-router-dom';

class SpecialOffer extends React.Component{
    constructor(props){
        super(props);
        this.state = {}
    }
    componentDidMount(){
        this.props.specialOfferData && this.props.specialOfferData.forEach(specialContent => {
            this.setState({
                [specialContent.acf_fc_layout]: specialContent.content
            })
        })
    }
    render(){
        return(
            <div className="container-fluid cc-details-background">
                <div className="row">
                    <div className="col cc-details-title">
                        <div dangerouslySetInnerHTML={{ __html: this.state.hero_text_block}} />
                    </div>
                </div>
                <div className="row">
                    <div className="col cc-more-details">
                        {this.state.button_block && this.state.button_block.map((button, i) => 
                            <p key={i}>
                                <Link to={button.button_link}>
                                    {button.button_text}<span className="fa fa-chevron-right"></span>
                                </Link>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
export default SpecialOffer